import React from 'react';
import { History } from 'history';
import { Input, InputNumber, InputMultiline, InputSwitch, InputPicklist } from '../../components';
import BaseCreate from '../base/base-create.component'; 
import Model from './quizresult-model';  //editable..
import OwnerPicklist from '../owner/owner-picklist.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class QuizresultCreate extends  React.Component<IProps, IState> {
    constructor(props:IProps) {
        super(props);  
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
        this.onChange = this.onChange.bind(this);
    }
    
    private onLoadOwner = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'owner': data?.id, 'ownerCaption': data?.name || ''  }  });
    }
    
    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }

    render() {
        return (
            //editable..          
            <BaseCreate history={this.props.history} 
                model={Model} datarow={this.state.datarow} onError={this.onError}>               
          
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} onChange={this.onChange}/>
                <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                {AppService.isAppFullVersion() &&
                <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} error={this.state.errors?.owner} onChange={this.onChange} >
                    <OwnerPicklist currentId={this.state.datarow.owner} onLoad={this.onLoadOwner}/>
                </InputPicklist>
                } 
                <Input name='title' label='Title' value={this.state.datarow.title} error={this.state.errors?.title} onChange={this.onChange} />
                <InputMultiline name='content' label='Content' value={this.state.datarow.content} error={this.state.errors?.content} onChange={this.onChange} />
                <InputNumber name='seq' label='Seq' value={this.state.datarow.seq} error={this.state.errors?.seq} onChange={this.onChange} />
                <InputNumber name='valuemin' label='Value Min.' value={this.state.datarow.valuemin} error={this.state.errors?.valuemin} onChange={this.onChange} />
                <InputNumber name='valuemax' label='Value Max.' value={this.state.datarow.valuemax} error={this.state.errors?.valuemax} onChange={this.onChange} />
                <InputNumber name='scale' label='Scale' value={this.state.datarow.scale} error={this.state.errors?.scale} onChange={this.onChange} />
                <InputNumber name='factor' label='Factor' value={this.state.datarow.factor} error={this.state.errors?.factor} onChange={this.onChange} />
                <Input name='tag' label='Tag' value={this.state.datarow.tag} error={this.state.errors?.tag} onChange={this.onChange} />
                
            </BaseCreate>
        );
    }     
     
}